import {Component, Input, OnInit} from "@angular/core";
import {Invoice} from "../../dto/invoice";
import {ThemePalette} from "@angular/material/core";

@Component({
  selector: 'app-badge-with-loading',
  templateUrl: './badge-with-loading.component.html',
  styleUrls: ['./badge-with-loading.component.css']
})
export class BadgeWithLoadingComponent implements OnInit {

  @Input() isLoading: boolean;
  @Input() badgeText: string|null;
  @Input() title: string;
  @Input() badgeHidden: boolean = false;
  @Input() badgeColor: ThemePalette;

  constructor() { }

  ngOnInit(): void {
  }

}
